export const colors = {
  brandPrimary: '#0088FF',
  brandPrimaryDark: '#0066CC',
  brandNavy: '#113163',
  brandAccent: '#74D8F7',
  white: '#FFFFFF',

  textPrimary: '#1F1F1F',
  textWizard: '#0B1B3A',
  textMuted: '#666666',

  tealStart: '#17A6B3',
  tealEnd: '#3ED8D8',
  success: '#22C55E',

  accentBlueSoft: '#DBEAFE',
  surfaceSoft: '#EEF2F7',
  pageSurface: 'rgb(248 250 252 / var(--tw-bg-opacity, 1))',
  warningBg: '#FFFBE6',
  warningBorder: '#FFE58F',
  warningText: '#AD6800',

  borderLight: 'rgba(0,0,0,0.06)',
  borderLighter: 'rgba(0,0,0,0.08)',
  borderMuted: 'rgba(0,0,0,0.25)',
  textSecondary: 'rgba(0,0,0,0.65)',
  textTertiary: 'rgba(0,0,0,0.45)',
  overlayBlueSoft: 'rgba(0,136,255,0.10)',
  disabledPrimary: "rgba(0,136,255,0.5)",
} as const;

export const dreamCategoryColor = {
  Professional: "#3B82F6",
  Health: "#EF4444",
  Travel: "#F59E0B",
  Financial: "#10B981",
  Personal: "#8b5cf6",
};

export const monthLabels = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

export default colors
